module.exports = __webpack_public_path__ + "img/6_102.d2008822.png";